import { render, staticRenderFns } from "./SponsorAds.vue?vue&type=template&id=1f4a4cf5&scoped=true"
import script from "./SponsorAds.vue?vue&type=script&lang=js"
export * from "./SponsorAds.vue?vue&type=script&lang=js"
import style0 from "./SponsorAds.vue?vue&type=style&index=0&id=1f4a4cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a4cf5",
  null
  
)

export default component.exports